import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next";
import smartAlarm from "assets/img/smartAlarm.png";

const Alarm = (props) => {
  const { t } = useTranslation(['devices', 'common']);
  const [alert, setAlert] = React.useState(null);

  const deleteConfirmation = (id) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t('common:confirmUnlist')}
        onConfirm={() => successRemove(id)}
        onCancel={() => cancelRemove()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t('common:confirmYes')}
        cancelBtnText={t('common:cancel')}
        showCancel
        btnSize=""
      >
      </ReactBSAlert>
    );
  };
  
  const successRemove = (id) => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title={t('common:removed')}
        onConfirm={() => hideAlert(id)}
        onCancel={() => hideAlert(false)}
        confirmBtnBsStyle="success"
        btnSize=""
      >
        {t('deviceUnlisted')}
      </ReactBSAlert>
    );
  };
  const cancelRemove = () => {
    setAlert(
      <ReactBSAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title={t('common:cancelled')}
        onConfirm={() => hideAlert(false)}
        onCancel={() => hideAlert(false)}
        confirmBtnBsStyle="success"
        btnSize=""
      >
      </ReactBSAlert>
    );
  };
  
  const hideAlert = (id = false) => {
    setAlert(null);
    if (id) {
      props.alarmDelete(id);
    }
  };

  return (
    <>
      {alert}
      <Col xl="4" lg="6" md="6" xs="12">
      <motion.div 
        whileHover={{ scale: 1.03 }}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1}}
        transition={{ duration: 0.2 }}
      >
          <Card>
              <CardBody className="alerts_body">
              <div className="alerts_btns"><i className="alerts_icons tim-icons icon-settings-gear-63" onClick={() => props.alarmEnterEditMode(props.id)}/><i className="alerts_icons tim-icons icon-simple-remove" onClick={() => deleteConfirmation(props.id)}/></div>
              <Row className="h-100" onClick={() => props.alarmEnterEditMode(props.id)}>
                <Col xl="9" xs="10">
                    <div className="name">{t('common:name')}</div>
                    <div className="title">{props.name || t('common:notSetup')}</div>
                    <div className="alerts_desc">
                        <div className="name">{t('text')}</div>
                        <div className="title">{props.text || t('common:notSetup')}</div>
                    </div>
                </Col>
                <Col xl="3" xs="2" className="m-auto">
                    <img className="alerts_img" alt="icon" src={smartAlarm} />
                </Col>
              </Row>
              </CardBody>
          </Card>
        </motion.div>
      </Col>
    </>
  );
};

export default Alarm;